import {
  getGenreProfileStatsTableData,
  getGenreProfileStatsLineData,
  getGenreProfilePageDataMobile,
  getGenreProfileImgDataMobile,
  // getGenreProfileRegionAndCountriesListWhenOther,
  // getGenreProfileRegionAndCountriesListWhenTotalAndMobile,
} from '@/pages/intelligence/services/genreProfile';

export function translateStateParams(base: any, type?: string) {
  if (base.entity_type !== 'mobile') {
    return base;
  }
  const requestParams: any = {
    regions: (() => {
      if (
        base.data_tag === 'countries' &&
        base.regions.length === 1 &&
        base.regions[0] === 'global'
      ) {
        return [];
      }
      return [...base.regions];
    })(),
    entity_type: base.entity_type, // "mobile",
    regionType: 'market',
    genre_tab: base.genreType,
    genreSegment: 'all',
    genre_source: base.genre_source, // "iegg",
    granularity: base.granularity, // "monthly",
    start_date: base.start_date, // "",
    end_date: base.end_date, // "",
    iegg_genre_req: [],
    genre: [],
    metric_condition: base.metric_condition,
    source_metrics: (() => {
      // 这里要使用筛选器的值，可以从外部传进来
      const metrics: any = {};
      // todo: @yao 这里需要根据筛选器的值来判断
      // 如果有sensortower
      // if xxx
      metrics[base.dataSourceSingle] = [];
      // 如果在by_game页面，需要dau
      if (base.data_tag === 'games' && type === 'line') {
        if (base.granularity === 'daily') {
          metrics[base.dataSourceSingle].push('dau');
        }
        if (base.granularity === 'weekly') {
          metrics[base.dataSourceSingle].push('wau');
        }
        if (base.granularity === 'monthly') {
          metrics[base.dataSourceSingle].push('mau');
        }
      } else if (base.data_tag === 'games' && type !== 'line') {
        if (base.granularity === 'daily') {
          metrics[base.dataSourceSingle].push('avg_dau');
        }
        if (base.granularity === 'weekly') {
          metrics[base.dataSourceSingle].push('avg_wau');
        }
        if (base.granularity === 'monthly') {
          metrics[base.dataSourceSingle].push('avg_mau');
        }
      }
      return metrics;
    })(),
    genre_rank: [
      {
        [`${base.genreType}_genre`]: base.genre,
        source: 'iegg',
      },
    ],
    page: base.page,
    page_size: base.page_size,
  };
  // 处理参数有变的情况
  switch (base.data_tag) {
    case 'games':
      requestParams.group_by = ['game_id'];
      break;
    case 'countries':
      requestParams.group_by = ['market'];
      break;
    case 'companies':
      requestParams.group_by = ['publisher_id'];
      break;
  }
  if (base.order_by) {
    const keyMap: any = {
      annie_revenue: 'revenue',
      annie_download: 'download',
      annie_revenue_ratio: 'revenue_growth',
      annie_download_ratio: 'download_growth',
      sensor_revenue: 'revenue',
      sensor_download: 'download',
      sensor_revenue_ratio: 'revenue_growth',
      sensor_download_ratio: 'download_growth',
      date: 'date',
      sensor_avg_mau: 'avg_mau',
      sensor_avg_mau_ratio: 'avg_mau_growth',
      sensor_avg_dau: 'avg_dau',
      sensor_avg_dau_ratio: 'avg_wau_growth',
      sensor_avg_wau: 'avg_wau',
      sensor_avg_wau_ratio: 'avg_wau_growth',
      annie_avg_mau: 'avg_mau',
      annie_avg_mau_ratio: 'avg_mau_growth',
      annie_avg_dau: 'avg_dau',
      annie_avg_dau_ratio: 'avg_wau_growth',
      annie_avg_wau: 'avg_wau',
      annie_avg_wau_ratio: 'avg_wau_growth',
    };
    requestParams.order_by = [`${keyMap[base.order_by]} ${base.order}`];
  } else {
    requestParams.order_by = [];
  }
  if (type === 'line') {
    switch (base.data_tag) {
      case 'games':
        requestParams.metric_condition = {
          game_ids: base.checkedList.map((e: any) => e.id),
        };
        break;
      case 'countries':
        requestParams.regions = base.checkedList.map((e: any) => e.name_abbr);
        break;
      case 'companies':
        requestParams.metric_condition = {
          publisher_ids: base.checkedList.map((e: any) => e.id),
        };
        break;
    }
    requestParams.order_by = ['date'];

    if (base.data_tag !== 'operation') {
      requestParams.group_by.push('date');
    }
    requestParams.page = 1;
    requestParams.page_size = 1000000000;
  }
  if (base.data_tag === 'operation') {
    requestParams.group_by = ['date'];
  }
  return requestParams;
}

export function translateStateListFunc(base: any) {
  if (base.entity_type != 'mobile') {
    return getGenreProfileStatsTableData;
  }
  return getGenreProfilePageDataMobile;
}

export async function translateStateResponse(base: any, req: any, result: any) {
  if (base.entity_type != 'mobile') {
    return result;
  }

  // 反转回之前的数据结构
  let mobileData: any;
  // 换算游戏详情
  let gameRet: any;
  // 如果需要游戏详情
  if (base.data_tag == 'games') {
    var game_ids = result?.list?.map((e: any) => e.game_id);
    gameRet = await getGenreProfileImgDataMobile({
      ids: game_ids,
      entity_type: base.entity_type,
      level: 'full',
    });
  }
  let companyRet: any;
  if (base.data_tag == 'companies') {
    var game_ids = result?.list?.map((e: any) => e.publisher_id);
    companyRet = await getGenreProfileImgDataMobile({
      ids: game_ids,
      entity_type: 'company',
      level: 'full',
    });
  }
  // mix回原本的结构中
  mobileData = result?.list?.map((e: any) => {
    const game = gameRet?.data?.[e.game_id] || {};
    return {
      ...(() => {
        // by_game 的情况
        if (base.data_tag == 'games') {
          return {
            id: game.id,
            cover: game.cover,
            name: game.entity_name,
            release_time: game.release_time,
            genre: game.iegg_genre,
            sub_genre: game.iegg_sub_genre,
            markets: game.country_abbre,
            publisher: game.publisher,
            location_country: game.country_name_en,
          };
        }
        // by countries的情况
        if (base.data_tag == 'countries') {
          return {
            name_abbr: e.market,
            // todo: @yao 国家的名字自己换算
          };
        }
        // by companies的情况
        if (base.data_tag == 'companies') {
          const company = companyRet?.data?.[e.publisher_id] || {};
          return {
            id: company.uuid,
            cover: company.image_url,
            name: company.name,
            markets: company.country_name_abbre,
            // todo: @yao 这里可能有点问题，自己看
            location_country: company.location_identifiers_country,
            location_city: company.location_identifiers_city,
          };
        }
        if (base.data_tag === 'operation') {
          return { ...e };
        }
      })(),
      metrics: (() => {
        const metrics = [];
        // todo: @yao 这里需要根据筛选器的值来判断
        // sensortower的情况
        // if xxx
        const pushAu = function (ds: any) {
          if (base.data_tag != 'games') {
            return;
          }
          const mp: any = {
            sensortower: 'sensor',
            appannie: 'annie',
          };
          if (base.granularity === 'daily') {
            metrics.push({
              metric: `${mp[ds]}_avg_dau`,
              source: ds,
              value: e.metrics?.[`${ds}_avg_dau`],
              dod: e.metrics?.[`${ds}_avg_dau_growth`],
            });
          }
          if (base.granularity === 'weekly') {
            metrics.push({
              metric: `${mp[ds]}_avg_wau`,
              source: ds,
              value: e.metrics?.[`${ds}_avg_wau`],
              dod: e.metrics?.[`${ds}_avg_wau_growth`],
            });
          }
          if (base.granularity === 'monthly') {
            metrics.push({
              metric: `${mp[ds]}_avg_mau`,
              source: ds,
              value: e.metrics?.[`${ds}_avg_mau`],
              dod: e.metrics?.[`${ds}_avg_mau_growth`],
            });
          }
        };
        for (const ds in req.source_metrics) {
          if (ds == 'sensortower') {
            metrics.push({
              metric: 'sensor_revenue',
              source: 'sensortower',
              value: e.metrics?.sensortower_revenue,
              dod: e.metrics?.sensortower_revenue_growth,
            });
            metrics.push({
              metric: 'sensor_download',
              source: 'sensortower',
              value: e.metrics?.sensortower_download,
              dod: e.metrics?.sensortower_download_growth,
            });
          }
          if (ds == 'appannie') {
            metrics.push({
              metric: 'annie_revenue',
              source: 'appannie',
              value: e.metrics?.appannie_revenue,
              dod: e.metrics?.appannie_revenue_growth,
            });
            metrics.push({
              metric: 'annie_download',
              source: 'appannie',
              value: e.metrics?.appannie_download,
              dod: e.metrics?.appannie_download_growth,
            });
          }
          pushAu(ds);
        }
        return metrics;
      })(),
    };
  });
  return mobileData;
}
